export default __webpack_public_path__ + "static/media/calendar 2.2ac4731b.svg";